module.exports = __webpack_public_path__ + "img/44.6e1a8651.jpg";